export const ACTION_TYPES = {
    ACTION: 'Action',
    BADGE: 'Badge',
} as const;

export type ActionType = (typeof ACTION_TYPES)[keyof typeof ACTION_TYPES];
